import { render, staticRenderFns } from "./PSDArtboardsPreview.vue?vue&type=template&id=aa6d67ca&scoped=true"
import script from "./PSDArtboardsPreview.vue?vue&type=script&lang=js"
export * from "./PSDArtboardsPreview.vue?vue&type=script&lang=js"
import style0 from "./PSDArtboardsPreview.vue?vue&type=style&index=0&id=aa6d67ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d67ca",
  null
  
)

export default component.exports